import { useAxios } from 'hooks/utils';
import deviceRpcService from 'services/rpc/deviceRpcService';

export default function useDeviceRpcService() {
  return deviceRpcService(useAxios());
}
